// pages/Privacy.js
import React from "react";
import { Box, Container, Typography, Link, Paper } from "@mui/material";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";

export default function Privacy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy – SortlyBooks</title>
      </Helmet>
      <Navbar />
      <Box sx={{ height: { xs: 72, md: 72 } }} />{" "}
      {/* Spacer for fixed navbar */}
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Paper
          elevation={0}
          sx={{ p: { xs: 3, md: 4 }, borderRadius: 3, backgroundColor: "#fff" }}
        >
          <Typography variant="h4" gutterBottom>
            Privacy Policy
          </Typography>

          <Typography variant="body2" paragraph>
            <strong>Effective Date:</strong> May 12, 2025
          </Typography>

          <Typography variant="body1" paragraph>
            SortlyBooks (“we”, “us”, or “our”) is committed to protecting your
            data. This policy outlines how we collect, use, and safeguard your
            information.
          </Typography>

          <Typography variant="h6" gutterBottom>
            1. What We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We collect your email address, uploaded receipts, preferences, and
            activity data. All data is securely stored using Firebase and Google
            Cloud services.
          </Typography>

          <Typography variant="h6" gutterBottom>
            2. How We Use Your Data
          </Typography>
          <Typography variant="body1" paragraph>
            We use your data to:
          </Typography>
          <ul style={{ paddingLeft: 20 }}>
            <li>Organize receipts and generate reports</li>
            <li>Send summaries to your accountant (if enabled)</li>
            <li>Improve product performance and user experience</li>
            <li>Notify you about important activity (e.g., monthly reports)</li>
          </ul>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            3. Data Sharing & Security
          </Typography>
          <Typography variant="body1" paragraph>
            We do <strong>not</strong> sell or share your personal information
            with third parties. Data is encrypted in transit and at rest.
            Receipt files are stored securely using Google Cloud Storage.
          </Typography>

          <Typography variant="h6" gutterBottom>
            4. Your Rights
          </Typography>
          <Typography variant="body1" paragraph>
            You can request deletion of your data at any time by contacting{" "}
            <Link href="mailto:support@sortlybooks.com">
              support@sortlybooks.com
            </Link>
            .
          </Typography>

          <Typography variant="h6" gutterBottom>
            5. Cookies
          </Typography>
          <Typography variant="body1" paragraph>
            We use minimal cookies to improve website performance and track
            anonymous usage stats via Plausible Analytics (EU-hosted,
            privacy-first).
          </Typography>

          <Typography variant="h6" gutterBottom>
            6. Updates to This Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We may update this Privacy Policy from time to time. If major
            changes occur, we will notify you via email or in-app notification.
          </Typography>

          <Typography variant="h6" gutterBottom>
            7. Contact
          </Typography>
          <Typography variant="body1" paragraph>
            For any questions, email us at{" "}
            <Link href="mailto:support@sortlybooks.com">
              support@sortlybooks.com
            </Link>
            .
          </Typography>
        </Paper>
      </Container>
    </>
  );
}
